<template>
  <div class="app-page box-card">

    <div class="box-card-content">
      <el-alert
        :title="$t('promotionSystemHint')"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 18px;"
      />
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="姓名/用户ID/交易账号">
            <template slot="label">
              <I18Lang id="proxycust4" defaultText="姓名/用户ID/交易账号" />
            </template>
            <el-input style="width:250px" :placeholder="$t('proxycust128')" size="small"
              v-model="queryForm.username"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <template slot="label">
              <I18Lang id="proxymoney5" defaultText="状态" />
            </template>
            <el-select size="small" v-model="queryForm.auth_status" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in statusList" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>
        </el-form>

        <el-form>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </el-form>

      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="姓名" prop="username">
            <template slot="header">
              <I18Lang id="index21" defaultText="姓名" />
            </template>
          </el-table-column>
          <el-table-column width="180" label="用户ID" prop="account_id">
            <template slot="header">
              <I18Lang id="proxycust15" defaultText="用户ID" />
            </template>
          </el-table-column>
          <el-table-column width="180"  label="交易账号" prop="account_no">
            <template slot="header">
              <I18Lang id="proxycust26" defaultText="交易账号" />
            </template>
          </el-table-column>
          <!-- <el-table-column label="杠杆比例" prop="leverage">
            <template slot="header">
              <I18Lang id="proxycust18" defaultText="杠杆比例" />
            </template>
          </el-table-column>
          <el-table-column label="融资倍数" prop="financing_multiple">
            <template slot="header">
              <I18Lang id="proxycust20" defaultText="融资倍数" />
            </template>
          </el-table-column> -->
          <el-table-column width="200"  label="当前现金账户余额($)" prop="cash_balance">
            <template slot="header">
              <I18Lang id="proxycust29" defaultText="当前现金账户余额($)" />
            </template>
          </el-table-column>
          <el-table-column label="当前交易账户余额($)" prop="trade_balance">
            <template slot="header">
              <I18Lang id="proxycust30" defaultText="当前交易账户余额($)" />
            </template>
          </el-table-column>
          <el-table-column width="160" label="首次入金时间" prop="recharge_time">
            <template slot="header">
              <I18Lang id="proxycust31" defaultText="首次入金时间" />
            </template>
          </el-table-column>
          <el-table-column width="160" label="注册时间" prop="create_time">
            <template slot="header">
              <I18Lang id="proxycust32" defaultText="注册时间" />
            </template>
          </el-table-column>
          <el-table-column width="150" label="状态" prop="parent_account_id">
            <template slot="header">
              <I18Lang id="proxycust33" defaultText="状态" />
            </template>
            <template slot-scope="">
              <StatusText :status="2" :text="statusList[2]" />
            </template>
          </el-table-column>

          <el-table-column width="150" label="操作" prop="name">
            <template slot="header">
              <I18Lang id="proxycust34" defaultText="状态" />
            </template>
            <template slot-scope="scope">
              <div class="operat-group">
                <span class="operat-item btn-auth"
                  v-if="scope.row.auth_status === 1 && userInfo.identity === 1"
                  @click="onOperat(scope.row, 'audit')"></span>
                <span class="operat-item btn-query" @click="onOperat(scope.row, 'look')"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="total, prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="dialogTypeTitle[dialogType]" :visible.sync="dialog.createUser" width="528px"
      :close-on-click-modal="false" :close-on-press-escape="false" class="info-dialog create-dialog">

      <el-form :model="formData" :rules="rules" ref="formData" class="reset-from">
        <el-form-item label="姓名" prop="username">
          <template slot="label">
            <I18Lang id="proxycust13" defaultText="姓名" />
          </template>
          <el-input @blur="usernameBlur" :disabled="dialogType === 'edit'" :placeholder="$t('proxyproxy57')"
            v-model="formData.username" size="small"></el-input>
        </el-form-item>

        <div class="form-item">
          <div class="form-item-label">
            <I18Lang id="proxycust15" defaultText="用户ID" />
          </div>
          <div class="form-item-value">{{ formData.account_id }}</div>
        </div>

        <el-form-item label="登录密码" prop="password">
          <template slot="label">
            <I18Lang id="proxycust16" defaultText="登录密码" />
          </template>
          <el-input type="password" :placeholder="$t('proxycust17')" v-model="formData.password"
            size="small"></el-input>
        </el-form-item>

        <el-form-item label="Phone Number">
          <el-input class="phone-input" v-model="formData.phone_number" placeholder="Please enter your phone number">
            <el-select v-model="formData.phone_code" slot="prepend" placeholder="Please select">
              <el-option v-for="(item, key) in countryCodes" :key="key" :label="`${item.name} (+${item.code})`"
                :value="item.code"></el-option>
            </el-select>
          </el-input>
        </el-form-item>

        <el-form-item label="邮箱">
          <template slot="label">
            <I18Lang id="index24" defaultText="邮箱" />
          </template>
          <el-input :placeholder="$t('proxyproxy13')" v-model="formData.email" size="small"></el-input>
        </el-form-item>

        <el-form-item>
          <div class="footer-view">
            <div class="btn kg-btn2" @click="dialog.createUser = false">
              <I18Lang id="my58" defaultText="取消" />
            </div>
            <div class="btn kg-btn2" @click="submitForm" type="primary">
              <I18Lang id="my25" defaultText="确定" />
            </div>
          </div>
        </el-form-item>
      </el-form>

    </el-dialog>

    <el-dialog
      :title="auditDialogType === 'look' ? `${$t('my97')}` : `${$t('proxymoney27')}`"
      :visible.sync="dialog.operat" width="30%" class="info-dialog" :class="auditDialogType"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="left">
        <el-descriptions :colon="false" class="descriptions-info" :column="1">
          <el-descriptions-item label="姓名">
            <template slot="label">
              <I18Lang id="proxycust13" defaultText="姓名" />
            </template>
            {{ currentData.username }}</el-descriptions-item>
          <el-descriptions-item label="用户ID">
            <template slot="label">
              <I18Lang id="proxycust15" defaultText="用户ID" />
            </template>
            {{ currentData.account_id }}
          </el-descriptions-item>
          <el-descriptions-item label="交易账号">
            <template slot="label">
              <I18Lang id="proxycust26" defaultText="交易账号" />
            </template>
            {{ currentData.account_no }}
          </el-descriptions-item>
          <!-- <el-descriptions-item label="杠杆比例">
            <template slot="label">
              <I18Lang id="proxycust18" defaultText="杠杆比例" />
            </template>
            {{ currentData.leverage }}
          </el-descriptions-item> -->
          <!-- <el-descriptions-item label="融资倍数">
            <template slot="label">
              <I18Lang id="proxycust20" defaultText="融资倍数" />
            </template>
            {{ currentData.financing_multiple }}
          </el-descriptions-item> -->
          <template v-if="auditDialogType !== 'audit'">
            <el-descriptions-item label="现金账户余额($)">
              <template slot="label">
                <I18Lang id="proxycust29" defaultText="当前现金账户余额($)" />
              </template>
              {{ currentData.cash_balance }}
            </el-descriptions-item>
            <el-descriptions-item label="交易账户余额($)">
              <template slot="label">
                <I18Lang id="proxycust30" defaultText="当前交易账户余额($)" />
              </template>
              {{ currentData.trade_balance }}
            </el-descriptions-item>
            <el-descriptions-item label="首次入金时间">
              <template slot="label">
                <I18Lang id="proxycust31" defaultText="首次入金时间" />
              </template>
              {{ currentData.recharge_time }}
            </el-descriptions-item>
            <el-descriptions-item label="注册时间">
              <template slot="label">
                <I18Lang id="proxycust32" defaultText="注册时间" />
              </template>
              {{ currentData.create_time }}
            </el-descriptions-item>
          </template>

          <template v-if="auditDialogType === 'audit'">
            <el-descriptions-item labelClassName="bank-descriptions-item" label="银行信息">
              <template slot="label">
                <div class="bank-info">
                  <p>
                    <I18Lang id="proxymoney62" defaultText="银行信息" />
                  </p>
                  <p>
                    <I18Lang id="proxymoney63" defaultText="开户人" />
                    {{ currentData.bank_user }}
                  </p>
                  <p>
                    <I18Lang id="proxymoney64" defaultText="银行名称" />
                    {{ currentData.bank_name }}
                  </p>
                  <p>
                    <I18Lang id="proxymoney65" defaultText="银行卡号" />
                    {{ currentData.bank_no }}
                  </p>
                  <p> <span> Swift Code</span> {{ currentData.swift_code }}</p>
                </div>
              </template>

            </el-descriptions-item>
            <el-descriptions-item label="审批">
              <template slot="label">
                <I18Lang id="proxycust35" defaultText="审批" />
              </template>
              <el-radio-group v-model="formAudit.auth_status">
                <el-radio :label="2">
                  <I18Lang id="proxycust37" defaultText="通过" />
                </el-radio>
                <el-radio :label="3">
                  <I18Lang id="proxycust38" defaultText="不通过" />
                </el-radio>
              </el-radio-group>
            </el-descriptions-item>
          </template>

        </el-descriptions>
        <template v-if="auditDialogType === 'audit'">
          <div v-if="formAudit.auth_status === 3">
            <el-input type="textarea" class="reset-input audit-input" v-model="formAudit.auth_remark"
              :placeholder="$t('public20')"></el-input>
          </div>
        </template>
         <div slot="footer" class="dialog-footer">
          <div class="kg-btn2" @click="dialog.operat = false">
            <I18Lang id="my58" defaultText="取消" />
          </div>
          <template v-if="auditDialogType === 'audit'">
            <div class="kg-btn2" type="primary" @click="onAudit">
              <I18Lang id="my25" defaultText="确定" />
            </div>
          </template>
        </div>
      </div>
      <div class="right">
        <!-- <div class="id-card">
          <div class="id-card-title">ID card</div>
          <img :src="currentData.id_pic_a_url" alt="">
          <img :src="currentData.id_pic_b_url" alt="">
        </div> -->

      </div>

    </el-dialog>

  </div>
</template>

<script>
import { formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import http from '@utils/http'
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
import StatusText from '@/components/StatusText'
import { auditStatusProxyList } from '@utils/global'
export default {
  name: 'record',
  data () {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the user name')) // '请输入姓名'
      } else {
        http.post('/api/user/checkIsExist', { username: value }).then(result => {
          if (result.is_exist) {
            callback(new Error(i18n.t('public9'))) // 用户名已经存在，请填写其他用户名
            return false
          } else {
            callback()
          }
        })
      }
    }

    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('public47')))
      } else {
        callback()
      }
    }

    const validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('proxyproxy59'))) // 请输入邮箱
      } else {
        var emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i
        if (!emailRegex.test(value)) {
          callback(new Error(i18n.t('public11'))) // '邮箱格式有误，请重填'
          return false
        } else {
          callback()
        }
      }
    }

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('proxyproxy58'))) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        callback()
      }
    }

    return {
      dialog: {
        createUser: false, // 预览图片
        operat: false
      },
      currentData: {},
      auditStatusProxyList,
      dialogTypeTitle: {
        add: this.$t('promotionInviteCode'),
        edit: this.$t('proxyproxy33') // '编辑'
      },
      dialogType: '',
      auditDialogType: '',
      countryCodes: [],
      formAudit: {
        id: '',
        auth_status: 2,
        auth_remark: ''
      },
      formData: {
        id: '',
        username: '',
        password: '',
        email: '',
        account_id: '',
        phone_number: '',
        phone_code: ''
      },
      rules: {
        username: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        phone_number: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { required: true, validator: validateEmail, trigger: 'change' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      statusList: auditStatusProxyList,
      queryForm: {
        username: '',
        auth_status: '',
        page: 1,
        size: 10
      },
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  created () {
    this.getRecord()
    this.$http
      .post('/api/user/countryCodes')
      .then((result) => {
        this.countryCodes = result
      })
    // 新推广体系下不再通过代理中心手工创建交易用户。
    // 旧链接中的 ?type=add 将被忽略，用户统一通过邀请码/邀请链接注册。
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/userDetailList?${formateObjToParamStr(
          params
        )}`
      )
    },
    getRecord () {
      this.$http.post('/api/agent/userDetailList', this.queryForm).then((result) => {
        this.tableData = result
      })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_date = val ? val[0] : ''
      this.queryForm.end_date = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    },
    usernameBlur () {
      this.$refs.formData.validateField(['username'], result => {
        if (!result) {
          this.$http.get('/api/user/registerAccountId').then((result) => {
            this.formData.account_id = result.account_id
          })
        }
      })
    },
    onOperat (item, type) { // 查看凭证
      this.auditDialogType = type
      this.currentData = item
      this.formAudit.id = item.id
      this.dialog.operat = true
    },
    onAudit () {
      this.$http.post('/api/agent/authUserDetail', this.formAudit).then(result => {
        this.getRecord()
        this.dialog.operat = false
      })
    },
    onCreate () {
      this.$message.info(this.$t('promotionSystemHint'))
      this.$router.push({ name: 'proxyPromotionCenter' })
    },
    submitForm () {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitProxy()
        } else {
          return false
        }
      })
    },
    submitProxy () { // 提交注册
      if (this.dialogType === 'add') {
        this.$http.post('/api/agent/createUser', {
          username: this.formData.username,
          password: this.formData.password,
          email: this.formData.email,
          account_id: this.formData.account_id
        }).then(result => {
          this.getRecord()
          this.$alert('<h3>User created successfully</h3>', '', {
            confirmButtonText: this.$t('my77'),
            // cancelButtonText: this.$t('public28'),
            customClass: 'success-alert',
            dangerouslyUseHTMLString: true
          }).then(() => {
          }).catch(() => {
          })
          this.dialog.createUser = false
          this.formData = {
            id: '',
            username: '',
            password: '',
            email: '',
            account_id: ''
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      }
    }
  },
  components: {
    StatusText
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 800px !important;
    min-height: 750px;
    height: 750px;
    background: url("../../../assets/img/dialog-bg/cust-list-info.png") no-repeat center / 100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 10px;
      }

      .el-dialog__headerbtn {
        margin-top: 18px;
      }
    }

    .el-dialog__body {
      display: flex;
      justify-content: space-between;

      .left {

        .audit-input {
        }

      }

    }

    .dialog-footer {
      margin-top: 20px;
      text-align: center;
      padding-right: 20px;
    }
  }

  &.audit {
    .el-dialog {
      min-height: 780px;
      height: 780px;

      .el-dialog__header {
        .el-dialog__title {
          padding-top: 0px;
        }

        .el-dialog__headerbtn {
          margin-top: 5px;
        }
      }
    }

    ::v-deep .bank-descriptions-item {
      width: 100%;
      flex: 0 0 100%;

      .el-descriptions-item__content {
        display: none;
      }
    }

    .bank-info {
      width: 100%;

      p {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
      }
    }
  }

  &.create-dialog {
    .el-dialog {
      width: 706px !important;
      min-height: 640px;
      height: 710px;
      background: url("../../../assets/img/dialog-bg/cust-create-bg.png") no-repeat center / 100% 100%;

      .el-dialog__header {
        .el-dialog__title {
          padding-top: 5px;
        }

        .el-dialog__headerbtn {
          margin-top: 8px;
        }
      }

      .phone-input {
        .el-input__inner {}

        .el-input-group__prepend {
          background: transparent;
          border-color: rgba(1, 178, 245, 0.5);
          border-radius: 0;
        }
      }

      .el-select .el-input,
      .el-select .el-input__inner {
        width: 150px;
        border: none;
        border-radius: 0;
      }

      .form-item {
        margin-bottom: 35px;

        .form-item-label {
          font-size: 16px;
          font-weight: 400;
          color: #01B2F5;
          margin-bottom: 10px;
        }

        .form-item-value {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: rgb(#FFFFFF, 0.6);
        }
      }
    }
  }
}

::v-deep .bank-descriptions-item {
  width: 100%;
  flex: 0 0 100%;

  .el-descriptions-item__content {
    display: none;
  }
}

.bank-info {
  width: 100%;

  p {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
</style>
